export default function product_quantity_init(){

    const container = document.querySelector('.elementor-add-to-cart .quantity')
    if( !container ) return;

    const input = container.querySelector('input[type="number"]');
    if( !input ) return;

    input.min = parseInt(input.min);
    input.max = parseInt(input.max);

    const reduce_button = document.createElement('div');
    reduce_button.classList.add('reduce', 'qty-btn');
    input.before(reduce_button);
    reduce_button.addEventListener('click', ()=>{
        reduce(input);
    })

    const add_button = document.createElement('div');
    add_button.classList.add('add', 'qty-btn');
    input.after(add_button);
    add_button.addEventListener('click', ()=>{
        add(input);
    })

}

function add(input){
    if( input.max && input.value >= input.max ) {
        input.value = input.max;
        return;
    }
    input.value++;
}

function reduce(input){
    if( input.min && input.value <= input.min ) {
        input.value = input.min;
        return;
    }
    input.value--;
}